//export const baseUrl  = "http://54.243.222.197:3001"
export const baseUrl  = "https://api.quettaq.co.kr"
 //export const baseUrl  = "http://localhost:3001"
export const RAZORPAY_KEY  = "rzp_test_YriauGTf9yCbV1"